export const EXAM_MODE = {
  EDIT: 'EDIT',
  VIEW: 'VIEW',
};

export const EXAM_STATUS = {
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFTED',
};
